import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent.vue";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent.vue";
import MakcDialogComponent2 from "@/profile/components/UI/MakcDialogComponent2.vue";
import MakcInputComponent from "@/profile/components/UI/MakcInputComponent.vue";
import MakcFilesComponent from "@/profile/components/UI/MakcFilesComponent.vue";

export default [
    MakcButtonComponent,
    MakcDialogComponent,
    MakcDialogComponent2,
    MakcInputComponent,
    MakcFilesComponent
]